<template>
<div>
        <div>
            <h3>Liste des clés</h3>
        </div>
        <div>
            <v-flex xs12>
                <v-layout align-center justify-end fill-height>
                    <v-btn
                        rounded
                        color="primary"
                        class="text-capitalize  mr-2"
                        @click="openKeyGeneration()">
                        Générer
                        <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                </v-layout>
            </v-flex>
        </div>
        <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            color="primary"
            :top="true"
            :right="true">
            {{ snackbar_message }}
        </v-snackbar>
    <div>
        <v-simple-table fixed-header class="mt-4">
            <thead>
                <tr>
                    <th class="text-left">Nom de l'application</th>
                    <th class="text-left">URL du site</th>
                    <th class="text-left">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in keys" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.redirect }}</td>
                    <td>
                        <v-icon
                            small
                            @click="deleting(item)"
                        >
                            mdi-trash-can-outline
                        </v-icon></td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
    <v-layout justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            hide-overlay
            max-width="290">
        <v-card>
            <v-card-title class="headline">Suppression</v-card-title>
            <v-card-text>{{delete_message}}</v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="orange" @click="dialog = false">Non</v-btn>
            <v-btn rounded color="primary" @click="deleteKey()">Oui</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-layout>
    <v-layout justify-center>
        <v-dialog v-model="formDialog" persistent max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Générer une nouvelle clé d'API pour votre application</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="close">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <form>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="key.app_name"
                                        label="Nom de l'application*"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('nom')"
                                        data-vv-name="nom"
                                        required
                                        outlined>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="key.app_url"
                                        label="URL du site*"
                                        v-validate="'required|url'"
                                        :error-messages="errors.collect('url')"
                                        data-vv-name="url"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 class="text-center mb-4">
                                    <v-btn color="primary" :loading="loading" :disabled="loading" @click="generateApiKey()">Générer</v-btn>
                                </v-flex>
                                <v-flex xs12 sm8 md10>
                                    <v-text-field
                                        v-model="currentKey"
                                        readonly
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4 md2 class="mb-1">
                                    <v-btn
                                        color="info darken-1"
                                        v-clipboard:copy="currentKey"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">
                                        Copier
                                    </v-btn>
                                </v-flex>
                                <v-flex xs13>
                                    <p v-if="copyMessage">{{defaultText}}</p>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</div>
</template>
<script>
import { mapGetters } from "vuex"
import axios from "axios"

export default {
    name: "api-keys-view",
    data() {
        return {
            key: {
                app_name: '',
                app_url: ''
            },
            formDialog: false,
            currentKey: null,
            keyId: null,
            dialog: false,
            defaultText: 'Please copy your new personal access token now. It won\'t be shown again for your security.',
            loading: false,
            snackbar: false,
            copyMessage: false,
            snackbar_message: '',
            delete_message: ''
        }
    },
    created() {
        this.$store.dispatch('fetchKeys')
    },
    computed: {
        ...mapGetters([
            'keys'
        ])
    },
    methods: {
        deleting(item) {
            this.keyId = item.id
            this.delete_message = 'Etes-vous sûr de vouloir supprimer cette clé ?'
            this.dialog = true
        },
        async deleteKey( ) {
            await this.$store.dispatch('deleteKey', this.keyId)
            this.dialog = false
            this.snackbar = true
            this.snackbar_message = "Clé supprimée avec succès!"
        },
        openKeyGeneration() {
            this.formDialog = true
        },
        async generateApiKey() {
            if (await this.formHasErrors()) return
            this.loading = true
            await axios.post('api/applications', this.key)
                .then(response => {
                    this.currentKey = response.data.token
                    this.snackbar = true
                    this.snackbar_message = "Clé générée avec succès!"
                    this.loading = false
                    this.copyMessage = true
                    this.$store.dispatch('fetchKeys')
                    this.key.app_name = ''
                    this.key.app_url = ''
                    this.$validator.reset()
                    })
                .catch(err => {
                    console.log(' Key creation error ', err)
                    this.formDialog = false
                    this.loading = false
                    })
        },

        onCopy: function (e) {
            this.snackbar = true
            this.snackbar_message = "Clé copiée!"
        },
        onError: function (e) {
            console.log('Failed to copy texts', e)
        },
        close(){
            this.formDialog = false
            this.key.app_name = ''
            this.key.app_url = ''
            this.$validator.reset()
        }

    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/api/index.vue